import React, { createContext, useContext, useState } from "react";

const pageContext = createContext();

export function PageProvider({ children }) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  document.title = "Nashi - " + title;
  const updatePageTitle = (newTitle, newDescription) => {
    setTitle(newTitle);
    setDescription(newDescription || "");
  };

  return (
    <pageContext.Provider value={{ title, description, updatePageTitle }}>
      {children}
    </pageContext.Provider>
  );
}

export function useMainPageTitle() {
  return useContext(pageContext);
}

export default PageProvider;
